module.exports = __webpack_public_path__ + "img/keitaro-addition.ru.1cf7c334.jpg";